import * as actionTypes from './actionTypes';
import { serviceCreateUser, serviceRefreshToken } from './service';
import { openModal } from '@app/src/commons/modal/state/modals/actions';
import { CONSTANTS } from './constants';

const fetchCreateUserRequest = () => ({
  type: actionTypes.FETCH_CREATEUSER_REQUEST
});

const fetchCreateUserFailure = (errorMessage: string, errorRol?: boolean) => ({
  type: actionTypes.FETCH_CREATEUSER_FAILURE,
  errorMessage,
  errorRol
});

const fetchCreateUserSuccess = (data) => ({
  type: actionTypes.FETCH_CREATEUSER_SUCCESS,
  data
});

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

export const fetchCreateUser = (url: string, values: Object | any): Function => {
  return async dispatch => {
    dispatch(fetchCreateUserRequest());
    try {
      values.rol = values.rol ? parseFloat(values.rol) : 0;
      const data = await serviceCreateUser.getData(url, values);
      dispatch(fetchCreateUserSuccess(data));
      dispatch(openModal('CREATE_USER_SUCCESS_MODAL'));
    } catch (error) {
      if (error.code === CONSTANTS.notAuthorized) {
        dispatch(fetchRefreshToken(url, values));
        return;
      }
      if (error.code === 132) {
        dispatch(fetchCreateUserFailure('Error de validación de rol. Vuelva a iniciar sesión.', true));
        dispatch(openModal('CLOSE_SESSION_MODAL'));
        return;
      }
      showError(dispatch, error);
    }
  }
};

const fetchRefreshToken = (url: string, values: Object) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      const value = await serviceCreateUser.getData(url, values, data.accessToken);
      dispatch(fetchCreateUserSuccess(value));
      dispatch(openModal('CREATE_USER_SUCCESS_MODAL'));
    } catch (error) {
      showError(dispatch, error);
    }
  }
};

const showError = (dispatch, error) => {
  if (error.code === CONSTANTS.code) {
    dispatch(fetchCreateUserFailure(CONSTANTS.existingMail));
    dispatch(openModal('CREATE_USER_FAILURE_MODAL'));
    return;
  }
  dispatch(fetchCreateUserFailure(CONSTANTS.errorOccurred));
  dispatch(openModal('CREATE_USER_FAILURE_MODAL'));
};
